import { INotification } from 'components/types/Notification'

interface INotificationWithoutType extends Omit<INotification, 'type'> {
  type?: 'error' | 'warning' | 'debug' | 'info' | 'success' | 'log'
}

const createNotificationEmitter = () => ({
  emitters: [] as ((notification: INotification) => void)[],
  emit(notifications: INotificationWithoutType | INotificationWithoutType[]) {
    const preparedNotification = Array.isArray(notifications) ? notifications : [notifications]

    for (const emitters of this.emitters) {
      for (const notification of preparedNotification) {
        emitters({ ...notification, type: notification.type || 'success' })
      }
    }
  },
  on(callback: (notification: INotification) => void) {
    this.emitters.push(callback)

    return () => {
      this.emitters = this.emitters.filter((i) => i !== callback)
    }
  }
})

export const ee = createNotificationEmitter()

export const notify = (notification: INotificationWithoutType | INotificationWithoutType[]) => ee.emit(notification)
